import React, { useEffect, useRef, useState } from 'react';
import { stats } from '../mock';

function useInView(ref) {
  const [inView, setInView] = useState(false);
  useEffect(() => {
    if (!ref.current) return;
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setInView(true); }, { threshold: 0.3 });
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [ref]);
  return inView;
}

export default function Stats() {
  const ref = useRef(null);
  const inView = useInView(ref);

  return (
    <section ref={ref} className="relative py-20 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-sky-500 via-cyan-500 to-teal-500" />
      <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'radial-gradient(circle at 30% 30%, rgba(255,255,255,0.6), transparent 40%), radial-gradient(circle at 80% 60%, rgba(255,255,255,0.3), transparent 40%)' }} />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center text-white">
          {stats.map((s, i) => (
            <div key={s.label} className={`transition-all duration-700 delay-${i * 100} ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
              <div className="font-display text-5xl md:text-6xl font-semibold tracking-tight">{s.value}</div>
              <div className="mt-2 text-sm tracking-widest uppercase text-white/85">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
